// extracted by mini-css-extract-plugin
module.exports = {"blocked":"g_c","loader":"g_d","img":"g_r","wrapper":"g_s","product__wave":"g_t"};